<template>
  <HomepageWideLayout>
    <div class="vheight">
      <div class="vcenter">
        <div class="vblock">
          <div class="wrapper">
            <div v-if="showWelcome">
              <h1>Welcome back!</h1>
              <h2>Sign in with email</h2>
            </div>

            <div v-if="badCreds || resetState === 'ok'">
              <div v-if="!resetState || resetState === 'busy'">
                <h1>That didn't work</h1>
                <h2>Try again?</h2>
                <h3 id="reset">or</h3>
                <h2>
                  <b-button
                    @click="reset"
                    class="reset-button"
                    variant="secondary"
                    style="color: white;"
                    href
                  >
                    <span v-if="resetState === 'busy'">Resetting your password...</span>
                    <span v-else>Reset your password</span>
                  </b-button>
                </h2>
              </div>
              <div v-else>
                <h1>Email sent</h1>
                <h2>Check your inbox</h2>
                <h3 id="reset">or</h3>
                <h2>
                  <b-button @click="reset" variant="secondary" style="color: white;" href>Send again</b-button>
                </h2>
              </div>
            </div>

            <div class="form-wrapper">
              <b-form-group
                class="signup-form"
                id="new_sign_up"
                @submit="submit"
                accept-charset="UTF-8"
                method="post"
              >
                <div class="signup-fieldset">
                  <b-form-input
                    v-model="email"
                    placeholder="Your email address"
                    required="required"
                    type="email"
                    class="signup-account-input"
                    autofocus="autofocus"
                    name="email"
                    pattern="[^@]+@[^@]+\.[a-zA-Z]*"
                  ></b-form-input>
                  <b-form-input
                    v-if="!forgot"
                    v-model="password"
                    placeholder="Password"
                    required="required"
                    type="password"
                    class="signup-account-input"
                    autofocus="autofocus"
                    name="password"
                  ></b-form-input>
                  <div class="error" v-if="loginError">{{loginError.toString()}}</div>

                  <b-button
                    v-if="!forgot"
                    @click="submit"
                    type="submit"
                    name="commit"
                    class="signup-account-submit"
                    :disabled="loginBusy || !formValid"
                  >
                    <span v-if="loginBusy">Signing In...</span>
                    <span v-else>Sign In</span>
                  </b-button>
                  <span id="forgot-password" v-if="!forgot" @click="forgot=true">Forgot password?</span>
                  <b-button v-if="forgot" @click="reset">
                    <span v-if="resetState === 'busy'">Sending...</span>
                    <span v-else>Send reset email</span>
                  </b-button>
                  <div
                    class="error"
                    v-if="resetState === 'error' && resetMessage"
                  >{{resetMessage.toString()}}</div>
                </div>
              </b-form-group>
            </div>

            <h3>or</h3>
            <div class="social-wrapper">
              <GoogleSignIn @login="onGoogleLogin"/>
              <LinkedInSignIn @login="onLinkedInLogin"/>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="hero-bottom">
          <img src="/static/images/footer/product_footer.png">
      </div>-->
    </div>
  </HomepageWideLayout>
</template>


<style lang="scss" scoped>
@import "~scss/colors";

.form-wrapper {
  display: block;
  width: 100%;
  margin: 0 auto;
}

.signup-fieldset {
  display: block;
  min-width: 250px;
  max-width: 500px;
}

.signup-form {
  width: 100%;
  background: $frost-0; //form background color
  margin: 20px auto;
}

.signup-account-input,
.signup-account-submit {
  width: 100%;
  font-weight: 400;
  border-radius: 0;
  padding: 10px 20px;
  margin: 10px auto;
}

.signup-account-submit {
  background-color: $red; //button background color
  border: $red 1px solid;
  color: $white; //button foreground color
}

.vheight {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: $frost-0; //div background color
}

.vblock {
  display: block;
}

.vcenter {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 160px);
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 350px;
  margin: 0 auto;
}

.social-wrapper {
  width: 100%;
  background: $frost-0; //div background color
  margin: 20px auto;
  padding: 0 11.25px;
}

.hero-bottom img {
  bottom: 0;
  width: 100%;
  height: auto;
  max-width: 974px;
  object-fit: cover;
  margin-top: 0;
}

h3 {
  width: 100%;
  color: $gray-1;
  font-style: italic;
  overflow: hidden;
  text-align: center;
}

h3:before,
h3:after {
  background-color: $gray-1; //horizonal line color
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
}

h3:before {
  right: 0.5em;
  margin-left: -50%;
}

h3:after {
  left: 0.5em;
  margin-right: -50%;
}

#reset {
  margin: 1em 0;
}

#forgot-password {
  color: $gray-1; //copy color
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    color: $gray-0; //hover color
  }
}

@media (max-width: 415px) {
  .vcenter {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}

/* Landscape */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  h1 {
    margin-top: 20px;
  }
}

/* Portrait iPad Pro */

@media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .vheight {
    height: calc(100vh - 150px);
  }
}

@import url("https://fonts.googleapis.com/css?family=Roboto");
@import "~scss/social.scss";
</style>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  meta: { title: "Sign In To Your Account" },
  data() {
    return {
      email: "",
      password: "",
      forgot: false
    };
  },
  computed: {
    ...mapGetters(["loginBusy", "loginError", "resetState", "resetMessage"]),
    badCreds() {
      return /Unable to login with provided credentials/.test(
        this.loginError || ""
      );
    },
    systemError() {
      return !this.badCreds && this.loginError;
    },
    showWelcome() {
      return !this.badCreds && this.resetState !== "ok";
    },
    formValid() {
      return this.email && this.password;
    }
  },
  methods: {
    ...mapActions(["login", "resetPassword", "socialAuth"]),
    async submit() {
      await this.login({ username: this.email, password: this.password });
      this.redirect();
    },
    async reset() {
      await this.resetPassword(this.email);
      if (this.resetState === "ok") {
        this.forgot = false;
      }
    },
    async onGoogleLogin(userinfo) {
      console.log("google user:", userinfo);
      await this.socialAuth({
        provider: "google",
        access_token: userinfo.auth.access_token
      });
      this.redirect();
    },
    async onFacebookLogin() {
      // not implemented
    },
    async onLinkedInLogin(info) {
      console.log("linkedin info:", info);
      await this.socialAuth(info);
      this.redirect();
    },
    redirect() {
      if (!this.loginError) this.$router.push("/dashboard");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/SignIn.vue